import { create } from 'zustand';

interface SubscriptionState {
  freeTrialsRemaining: number;
  freeTrialLimit: number;
  isFreeTrial: boolean;
  isLoading: boolean;
  lastFetched: number | null;
  hasPremiumFeatures: boolean;
  fetchSubscriptionStatus: () => Promise<void>;
  reset: () => void;
}

const useSubscriptionStore = create<SubscriptionState>((set, get) => ({
  freeTrialsRemaining: 0,
  freeTrialLimit: 3,
  isFreeTrial: false,
  isLoading: false,
  lastFetched: null,
  hasPremiumFeatures: true,

  fetchSubscriptionStatus: async () => {
    const { lastFetched } = get();
    const now = Date.now();
    
    // Only fetch if we haven't fetched in the last 5 minutes
    if (lastFetched && now - lastFetched < 5 * 60 * 1000) {
      return;
    }

    set({ isLoading: true });
    
    try {
      set({
        freeTrialsRemaining: 3,
        freeTrialLimit: 3,
        isFreeTrial: false,
        hasPremiumFeatures: true, 
        lastFetched: now,
      });
    } catch (error) {
      console.error("Error fetching subscription status:", error);
      // Keep the default values if the request fails
    } finally {
      set({ isLoading: false });
    }
  },

  reset: () => {
    set({
      freeTrialsRemaining: 0,
      freeTrialLimit: 3,
      isFreeTrial: false,
      isLoading: false,
      lastFetched: null,
      hasPremiumFeatures: true, 
    });
  },
}));

export default useSubscriptionStore; 